const hue = {
    id: 'hoi-an-hue',
    type: 'photoPost',
    countryId: 'seAsia',
    title: 'Hoi An & Hue in Photos',
    month: 'Feb',
    date: '5',
    content: [
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH1.jpg',
            detailText: 'Pháp Bảo Temple in Hoi An.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH2.jpg',
            detailText: 'We found a photoshoot at the temple gates of Tam Quan chùa Bà Mụ – these types of shoots with women in traditional outfits are very common in Vietnam.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH3.jpg',
            detailText: 'Hoi An is full of yellow walls, with shabby chic vibe from weather damage.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH4.jpg',
            detailText: 'One of the many beautiful lantern shops of Hoi An.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH5.jpg',
            detailText: 'The Japanese Covered Bridge in Hoi An\'s old town.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH6.jpg',
            detailText: 'Pink walls, too! Alice, her mom Judy, and sister Merilee.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH7.jpg',
            detailText: 'Lanterns AND yellow walls.'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH8.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH9.jpg'],
            detailText: 'So many beautiful photo opportunities.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH10.jpg',
            detailText: 'Dusk at the river in Hoi An.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH11.jpg',
            detailText: 'Merilee bought a lantern to release into the river.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH12.jpg',
            detailText: ''
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH13.jpg',
            detailText: 'We went on an evening street food tour in rainy Hue, traveling by cyclo. The drivers sit on super high bicycles behind the vestibules – it was once a normal mode of transport but is now only used by tourists.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH14.jpg',
            detailText: 'The bun thit nuong stall in our street food tour of Hue.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH15.jpg',
            detailText: 'The Imperial Palace in Hue.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH16.jpg',
            detailText: 'The palace was severely damaged during the French retreat in the 1940s and the American offensive in the 1970s. They\'ve restored a lot of it, but entire buildings are missing. It\'s sobering to walk through.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH17.jpg',
            detailText: 'The Imperial Palace in Hue.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH18.jpg',
            detailText: 'The Imperial Palace in Hue.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH19.jpg',
            detailText: 'The Imperial Palace in Hue.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/hoi-an-hue/HH20.jpg',
            detailText: 'Our favorite discovery from the food tour: salt coffee!! It tastes close to a Starbucks salted caramel drink, but much, much better. We went twice in 24 hours.'
        },
    ]
}

export default hue


// WEBPACK FOOTER //
// ./src/Posts/Content/hue.js